import { Analise } from "./Analise";

export default Analise;